<template lang="pug">
  vSelect.user-from-organization-select(:value="selectedOption" :options="options" label="username" @input="onInput" :placeholder="loading ? 'Loading...' : 'Select A User'" :disabled="loading")
</template>

<script>
import vSelect from 'vue-select'
import Security from '@/service/apis/Security';

export default {
  props: {
    organizationId: {
      type: Number,
      required: false
    },
    value: {
      type: Number,
      required: false
    }
  },
  data() {
    return {
      options: [],
      selectedOption: null,
      loading: false
    }
  },
  created() {
    if (this.organizationId) {
      this.fetchData()
    }
  },
  methods: {
    fetchData() {
      this.loading = true
      const req = {
        max: 1000,
        offset: 0
      }
      Security.listPrivelegedUsers(req, this.organizationId)
        .then((resp) => {
          this.options = resp.data.users.user
          this.updateSelectedOption()
        })
        .catch((e) => { this.$emit('error', e) })
        .then(() => { this.loading = false })
    },
    updateSelectedOption() {
      if (this.value) {
        this.selectedOption = this.options.find((o) => o.id === this.value)
      } else {
        this.selectedOption = null
      }
    },
    onInput(val) {
      this.selectedOption = val
      this.$emit('input', val ? val.id : null)
    },
    getSelectedUser() {
      return this.selectedOption
    }
  },
  watch: {
    value() {
      this.updateSelectedOption()
    },
    organizationId() {
      if (this.organizationId) {
        this.fetchData()
      } else {
        this.selectedOption = null
        this.options = []
      }
    }
  },
  components: {
    vSelect
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ssp/UserSelectFromOrganization.vue